import { BlocksContent } from '@strapi/blocks-react-renderer';
import { slugify } from './string';

export type Heading = {
  id: string;
  text: string;
};

// replaces the {{ string }} placeholders in the given text with
// React elements that highlight the content inside the placeholders.
export function highlightPlaceholdersElement(
  text: string,
  className?: string
): React.ReactElement {
  if (!text) {
    return <></>;
  }

  const placeholderRegex = /(\{\{[^}]+\}\})/g;

  const parts = text.split(placeholderRegex);

  const nodes = parts.map((part, index) => {
    const regex = /^\{\{([^}]+)\}\}$/;
    const match = regex.exec(part);
    if (match?.[1]) {
      const content = match[1].trim();
      return (
        <span key={`'content'-${index}`} {...(className && { className })}>
          {content}
        </span>
      );
    }
    return <span key={`'content'-${index}`}>{part}</span>;
  });

  return <>{nodes}</>;
}

export const extractHeadings = (content: BlocksContent): Heading[] => {
  const headings: Heading[] = [];

  if (Array.isArray(content)) {
    content.forEach((block, index) => {
      if (block.type === 'heading') {
        const text =
          block.children
            ?.map((child) => ('text' in child ? child.text : ''))
            .join('') || `Heading ${index}`;

        const id = slugify(text);

        headings.push({
          id,
          text
        });
      }
    });
  }

  return headings;
};
